/* RESPONSIBLE TEAM: team-actions */

import type Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

export default class AutomationFinAIAgentTasksRoute extends Route {
  @service declare intl: IntlService;
  @service declare store: Store;
  @service declare notificationsService: $TSFixMe;

  get titleToken() {
    return this.intl.t('standalone.tasks.list.title');
  }

  async model() {
    await Promise.all([
      this.store.findAll('instagram/integration').catch(() => {
        this.notificationsService.notifyError(
          this.intl.t('workflows.channels.instagram.business-accounts.loading-error'),
        );
      }),
      this.store
        .query('whatsapp/integration', { no_external_updates: true })
        .catch((_e: unknown) => []),
    ]);
  }
}
